module.exports = __webpack_public_path__ + "img/step4.5fd29908.png";